export default "__VITE_ASSET__XGrVCVYx__"